import * as React from "react";
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import { FileInfo } from "./FileInfo";


export interface FilesListItemProps {
    item: FileInfo;
    removeFile: (fileInfo: FileInfo) => void;
}

type PropsType = FilesListItemProps;

class FilesListItem extends React.PureComponent<PropsType> {

    render() {
        const { item, removeFile } = this.props;

        return <TableRow hover>
            <TableCell>{item.name}</TableCell>
            <TableCell align="right">
                <IconButton color="secondary" onClick={() => removeFile(item)}><CloseIcon fontSize="small" /></IconButton>
            </TableCell>
        </TableRow>;
    }
}

export default FilesListItem;

